import * as React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import links from '@/constants/links'
import Heading from '@/atoms/heading'
import NewTabLink from '@/atoms/new-tab-link'

const Bio = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      site {
        siteMetadata {
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author
  const social = data.site.siteMetadata?.social

  return (
    <div className="flex flex-wrap sm:flex-nowrap mb-10 py-4">
      <StaticImage
        className="mr-5 mb-2 w-20 rounded-full overflow-hidden"
        layout="fixed"
        formats={['auto', 'webp', 'avif']}
        src="../../images/profile-pic.jpg"
        width={50}
        height={50}
        quality={95}
        alt="Profile picture"
      />
      {author?.name && (
        <p className="sm:flex-1 w-full leading-7 text-white">
          Created by{' '}
          <NewTabLink
            className="text-secondary underline"
            link={links.MY_WEBSITE}
          >
            <strong>{author.name}</strong>
          </NewTabLink>
          , {author?.summary || null}
          <br />
          <br />
          There's a lot going on around blockchain, "decentralized" platforms,
          cryptos--name it. While this term is also confusing for me, I made
          (and am still making) some research around that field to understand
          them better. This space is going to serve as my diary for what I
          learn, and also as an opportunity to simplify this "strange" concept
          to other developers. Here's the first article{' '}
          <Link
            className="underline text-secondary"
            to={links.POST.INTRODUCTION}
          >
            What are "decentralized" platforms?
          </Link>
          <br />
          <br />
          <Heading level={2} className="text-secondary-500 mt-5 mb-2">
            Who am I?
          </Heading>
          I'm a Software Engineer, Developer Advocate, and Content Creator who
          loves creating different content on things I learn and work with in
          Tech. I currently write on{' '}
          {[
            { link: 'https://dillionmegida.com', label: 'my website' },
            {
              link: 'https://blog.logrocket.com/author/dillion-megida/',
              label: 'LogRocket',
            },
            {
              link: 'https://www.freecodecamp.org/news/author/dillionmegida/',
              label: 'FreeCodeCamp',
            },
            {
              link: 'https://www.freecodecamp.org/news/author/dillionmegida/',
              label: 'Vonage',
            },
          ].map(({ link, label }) => (
            <>
              <a className="text-secondary underline" href={link} key={link}>
                {label}
              </a>
              ,{' '}
            </>
          ))}{' '}
          with some articles on Strapi, Egghead, and few other platforms. I make
          money from writing and I want to share how I got into all these things
          for free, with you, here.
          <br />
          <br />
          Check out{' '}
          <Link className="text-secondary underline" to={links.BLOG}>
            the blog
          </Link>
          . Contents here will constantly be updated as I learn more ways to
          simplify blockchain concepts. That's really the goal of this platform.
          <br />
          <br />
          You can also{' '}
          <a
            className="text-secondary underline"
            href={`https://twitter.com/${social?.twitter || ``}`}
          >
            follow me on Twitter
          </a>
        </p>
      )}
    </div>
  )
}

export default Bio
